const CustomSeparator = () => {
  return <div className='text-textColor text-sm  md:text-2xl font-semibold'> {'>'} </div>
}

export default CustomSeparator
